/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Letterpreviewgreetingpt4Inputs */

const en_letterpreviewgreetingpt4 = /** @type {(inputs: Letterpreviewgreetingpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exmos. Senhores,`)
};

const pt_letterpreviewgreetingpt4 = /** @type {(inputs: Letterpreviewgreetingpt4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exmos. Senhores,`)
};

/**
* | output |
* | --- |
* | "Exmos. Senhores," |
*
* @param {Letterpreviewgreetingpt4Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const letterpreviewgreetingpt4 = /** @type {((inputs?: Letterpreviewgreetingpt4Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Letterpreviewgreetingpt4Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_letterpreviewgreetingpt4(inputs)
	return pt_letterpreviewgreetingpt4(inputs)
});
export { letterpreviewgreetingpt4 as "letterPreviewGreetingPT" }